import React, { forwardRef } from "react";
import { Box, Typography } from "@mui/material";
import { FileUploadOutlined } from "@mui/icons-material";

import { ActionButton } from ".";

export const FileUpload = forwardRef(
  (
    { onFileDrop, onFileDragOver, onFileDragLeave, isDragging, selectedFile, onFileUpload, onFileChange, isUploading }: any,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => {
    return (
      <>
        <Box
          onDrop={onFileDrop}
          onDragOver={onFileDragOver}
          onDragLeave={onFileDragLeave}
          sx={{
            backgroundColor: isDragging ? "#f0f0f0" : "transparent",
            borderRadius: "6px",
            padding: "10px 16px",
            border: "1px dashed #000000",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            transition: "background-color 0.2s",
          }}
        >
          {/* Left side: icon + file name or placeholder */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FileUploadOutlined sx={{ fontSize: 32, color: "#674BF5", marginRight: "12px" }} />
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {selectedFile ? selectedFile : "Drag and drop file here or upload"}
              </Typography>
              <Typography variant="caption" sx={{ color: "#888" }}>
                Accepted: JPEG, PNG, PDF, DOC
              </Typography>
            </Box>
          </Box>

          {/* Right side: Upload button */}
          <ActionButton
            buttonText={selectedFile ? "Upload" : "Select File"}
            variant="outlined"
            loading={isUploading}
            disabled={isUploading}
            onClick={onFileUpload}
            sx={{
              borderColor: "#674BF5",
              color: "#674BF5",
              textTransform: "capitalize",
            }}
          />

          {/* Hidden file input for file selection */}
          <input
            ref={ref}
            type="file"
            accept=".jpeg,.jpg,.png,.pdf,.doc,.docx"
            onChange={onFileChange}
            style={{ display: "none" }}
          />
        </Box>
      </>
    );
  },
);
